import { ApplicationConfig, provideBrowserGlobalErrorListeners, ErrorHandler, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';

import { routes } from './app.routes';
import { GlobalErrorHandler } from './shared/services/error-handler.service';
import { helocReducer } from './shared/store/heloc/heloc.reducer';
import { HelocEffects } from './shared/store/heloc/heloc.effects';
import { prequalReducer } from './shared/store/prequal/prequal.reducer';
import { PreQualEffects } from './shared/store/prequal/prequal.effects';
import { quoteReducer } from './shared/store/quote/quote.reducer';
import { QuoteEffects } from './shared/store/quote/quote.effects';
import { contactReducer } from './shared/store/contact/contact.reducer';
import { ContactEffects } from './shared/store/contact/contact.effects';
import { careersReducer } from './shared/store/careers/careers.reducer';
import { CareersEffects } from './shared/store/careers/careers.effects';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideHttpClient(),
    provideStore({ 
      heloc: helocReducer,
      prequal: prequalReducer,
      quote: quoteReducer,
      contact: contactReducer,
      careers: careersReducer
    }),
    provideEffects(HelocEffects, PreQualEffects, QuoteEffects, ContactEffects, CareersEffects),
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() })
  ]
};
